/** @format */

import { IKeyAuth } from "types";
import { KEY_CONTEXT } from "utils";

export function useKey() {

  const setKeySite = ({ accessToken }: IKeyAuth) => {
    localStorage.setItem(KEY_CONTEXT.ACCESS_TOKEN, accessToken);
    // onUpdateParams({ taskDetailIsFetch: !taskDetailIsFetch })
  };

  const removeKeySite = () => {
    localStorage.removeItem(KEY_CONTEXT.ACCESS_TOKEN);
  };

  const getKey = (key: string) => {
    return localStorage.getItem(key);
  };

  const removeKey = (key: string) => {
    return localStorage.removeItem(key);
  };


  return {
    setKeySite,
    getKey,
    removeKey,
    removeKeySite,
  };
}
